var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main",class:[_vm.layout, {'is-loading': _vm.isLoading}]},[(_vm.isLoading)?_c('InitialLoader'):_vm._e(),_c(_vm.layout,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }